(function() {
    'use strict';

    angular
        .module('bhsApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('formulaire', {
            parent: 'entity',
            url: '/formulaire?page&sort&search',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'bhsApp.formulaire.home.title'
            },
            views: {
                'content@bhs': {
                    templateUrl: 'app/entities/formulaire/formulaires.html',
                    controller: 'FormulaireController',
                    controllerAs: 'vm'
                }
            },
            params: {
                page: {
                    value: '1',
                    squash: true
                },
                sort: {
                    value: 'id,asc',
                    squash: true
                },
                search: null
            },
            resolve: {
                pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams, PaginationUtil) {
                    return {
                        page: PaginationUtil.parsePage($stateParams.page),
                        sort: $stateParams.sort,
                        predicate: PaginationUtil.parsePredicate($stateParams.sort),
                        ascending: PaginationUtil.parseAscending($stateParams.sort),
                        search: $stateParams.search
                    };
                }],
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('formulaire');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        })
        .state('formulaire-detail', {
            parent: 'entity',
            url: '/formulaire/{id}',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'bhsApp.formulaire.detail.title'
            },
            views: {
                'content@bhs': {
                    templateUrl: 'app/entities/formulaire/formulaire-detail.html',
                    controller: 'FormulaireDetailController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('formulaire');
                    return $translate.refresh();
                }],
                entity: ['$stateParams', 'Formulaire', function($stateParams, Formulaire) {
                    return Formulaire.get({id : $stateParams.id}).$promise;
                }],
                previousState: ["$state", function ($state) {
                    var currentStateData = {
                        name: $state.current.name || 'formulaire',
                        params: $state.params,
                        url: $state.href($state.current.name, $state.params)
                    };
                    return currentStateData;
                }]
            }
        })
        .state('formulaire-detail.edit', {
            parent: 'formulaire-detail',
            url: '/detail/edit',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/formulaire/formulaire-dialog.html',
                    controller: 'FormulaireDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['Formulaire', function(Formulaire) {
                            return Formulaire.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('^', {}, { reload: false });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('formulaire.new', {
            parent: 'formulaire',
            url: '/new',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/formulaire/formulaire-dialog.html',
                    controller: 'FormulaireDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: function () {
                            return {
                                type: null,
                                verifie: false,
                                complet: false,
                                dateSaisie: null,
                                userSaisie: null,
                                dateVerification: null,
                                userVerification: null,
                                id: null
                            };
                        }
                    }
                }).result.then(function() {
                    $state.go('formulaire', null, { reload: 'formulaire' });
                }, function() {
                    $state.go('formulaire');
                });
            }]
        })
        .state('formulaire.edit', {
            parent: 'formulaire',
            url: '/{id}/edit',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/formulaire/formulaire-dialog.html',
                    controller: 'FormulaireDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['Formulaire', function(Formulaire) {
                            return Formulaire.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('formulaire', null, { reload: 'formulaire' });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('formulaire.delete', {
            parent: 'formulaire',
            url: '/{id}/delete',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/formulaire/formulaire-delete-dialog.html',
                    controller: 'FormulaireDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['Formulaire', function(Formulaire) {
                            return Formulaire.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('formulaire', null, { reload: 'formulaire' });
                }, function() {
                    $state.go('^');
                });
            }]
        });
    }

})();
